<template>
  <div
    class="alert"
    :class="classObject"
  >
    <button
      v-if="dismissible"
      type="button"
      data-dismiss="alert"
      aria-hidden="true"
      class="close"
    >
      ×
    </button>
    <slot name="header" />
    <slot />
  </div>
</template>

<script>
const AlertTypes = ['success', 'info', 'warning', 'danger']

/**
 * Alert.
 */
export default {
  name: 'CAlert',
  props: {
    /**
     * Тип.
     *
     * @values success, info, warning, danger
     */
    type: {
      default: 'success',
      validator (value) {
        return AlertTypes.includes(value)
      }
    },
    /**
     * Можно ли скрыть.
     */
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Возвращает классы alert-а.
     *
     * @returns {{"alert-success": boolean, "alert-info": boolean, "alert-warning": boolean, "alert-danger": boolean, "alert-dissmissible": Boolean}}
     */
    classObject () {
      return {
        'alert-success': this.type === 'success',
        'alert-info': this.type === 'info',
        'alert-warning': this.type === 'warning',
        'alert-danger': this.type === 'danger',
        'alert-dissmissible': this.dismissible
      }
    }
  }
}
</script>
<style lang="css">
</style>
